"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.squareDocs = void 0;
var squareDocs = exports.squareDocs = {
  name: 'square',
  category: 'Arithmetic',
  syntax: ['square(x)'],
  description: 'Compute the square of a value. The square of x is x * x.',
  examples: ['square(3)', 'sqrt(9)', '3^2', '3 * 3'],
  seealso: ['multiply', 'pow', 'sqrt', 'cube']
};